import React, { useEffect, useState } from 'react';
import {
  Modal,
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  Alert,
  ActivityIndicator,
} from 'react-native';
import {
  PAYGIFT_CLUB_CLAIM_BLOCKED_MESSAGE,
  isPaygiftClubClaimBlockedError,
  getPaygiftClubClaimBlockedUi,
  reportPaygiftClubClaimBlock,
} from '../utils/paygiftClubClaimBlock';

export function usePaygiftClaimBlockedModal() {
  const [state, setState] = useState({
    visible: false,
    message: PAYGIFT_CLUB_CLAIM_BLOCKED_MESSAGE,
    csContact: null,
  });

  const showFromError = (error) => {
    if (!isPaygiftClubClaimBlockedError(error)) return false;
    const ui = getPaygiftClubClaimBlockedUi(error);
    setState({
      visible: true,
      message: ui.message,
      csContact: ui.csContact,
    });
    return true;
  };

  const close = () => setState((prev) => ({ ...prev, visible: false }));

  const modal = (
    <PaygiftClaimBlockedModal
      visible={state.visible}
      message={state.message}
      csContact={state.csContact}
      onClose={close}
    />
  );

  return { showFromError, modal };
}

export default function PaygiftClaimBlockedModal({
  visible,
  message,
  csContact,
  onClose,
}) {
  const [sendState, setSendState] = useState('idle');

  useEffect(() => {
    if (visible) {
      setSendState('idle');
    }
  }, [visible]);

  const handleContactCs = async () => {
    if (sendState === 'sending' || sendState === 'sent') {
      return;
    }
    setSendState('sending');
    try {
      await reportPaygiftClubClaimBlock(csContact);
      setSendState('sent');
    } catch (e) {
      setSendState('idle');
      Alert.alert(
        'Gagal mengirim laporan',
        e?.message || 'Silakan coba lagi, atau hubungi CS Zoolyfe secara manual.'
      );
    }
  };

  const sent = sendState === 'sent';
  const sending = sendState === 'sending';

  return (
    <Modal
      animationType="fade"
      transparent
      visible={!!visible}
      onRequestClose={onClose}
    >
      <View style={styles.overlay}>
        <View style={styles.card}>
          <Text style={styles.title}>Klaim Gagal</Text>
          <Text style={styles.message}>
            {message || PAYGIFT_CLUB_CLAIM_BLOCKED_MESSAGE}
          </Text>
          <TouchableOpacity
            style={[styles.csButton, sent && styles.csButtonSent]}
            onPress={handleContactCs}
            activeOpacity={sent ? 1 : 0.85}
            disabled={sending || sent}
          >
            {sending ? (
              <ActivityIndicator color="#FFFFFF" />
            ) : (
              <Text style={styles.csButtonText}>
                {sent ? 'Laporan kamu terkirim' : 'Hubungi CS Zoolyfe'}
              </Text>
            )}
          </TouchableOpacity>
          <TouchableOpacity style={styles.closeButton} onPress={onClose} activeOpacity={0.85}>
            <Text style={styles.closeButtonText}>Tutup</Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24,
  },
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    width: '100%',
    maxWidth: 340,
    paddingHorizontal: 22,
    paddingTop: 24,
    paddingBottom: 18,
  },
  title: {
    fontSize: 18,
    fontWeight: '700',
    color: '#111827',
    textAlign: 'center',
    marginBottom: 12,
  },
  message: {
    fontSize: 15,
    lineHeight: 22,
    color: '#374151',
    textAlign: 'center',
    marginBottom: 20,
  },
  csButton: {
    backgroundColor: '#FF6B35',
    borderRadius: 8,
    paddingVertical: 13,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 48,
    marginBottom: 8,
  },
  csButtonSent: {
    backgroundColor: '#16A34A',
  },
  csButtonText: {
    color: '#FFFFFF',
    fontSize: 15,
    fontWeight: '600',
  },
  closeButton: {
    paddingVertical: 10,
    alignItems: 'center',
  },
  closeButtonText: {
    color: '#6B7280',
    fontSize: 14,
    fontWeight: '500',
  },
});
